export const LAST_SIGNIN_USER_EMAIL = 'LAST_LOGIN_USER_EMAIL'; // 로그인 시도한 가장 마지막 이메일
export const PASSWORD_CHANGE_REQUIRED_ACCOUNTS = 'PASSWORD_CHANGE_REQUIRED_ACCOUNTS';
